import type { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import { getPendingClientLandingPath } from '../pages/companies/create-client-wizard/pendingClientSubscription';
import { getAuthenticatedLandingPath } from '../utils/permissionLanding';

interface GuestGuardProps {
  children: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const is2FAEnabled = localStorage.getItem('is2FAEnabled') === 'true';
  const isOtpVerified = localStorage.getItem('isOtpVerified') === 'true';
  const landingPath = getAuthenticatedLandingPath(user);
  const redirectFrom = (location.state as { from?: { pathname?: string } })?.from?.pathname;

  if (isAuthenticated) {
    const pendingPath = getPendingClientLandingPath();
    const redirectTo = pendingPath
      ? pendingPath
      : redirectFrom && redirectFrom !== '/login' && !redirectFrom.startsWith('/projects')
        ? redirectFrom
        : landingPath;
    return <Navigate to={redirectTo} replace />;
  }

  if (is2FAEnabled && !isOtpVerified) {
    return <Navigate to="/login/two-factor-authentication" />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default GuestGuard;
